import React from "react";
import { SourcesList, SourceItem, SourceLink } from "./SourcesDisplay.styles";

export const SourcesDisplay = ({ sources, t }) => {
  if (!Array.isArray(sources) || sources.length === 0) return null;

  return (
    <SourcesList>
      {sources.map((source, index) => (
        <SourceItem key={index}>
          <SourceLink
            href={source.url}
            target="_blank"
            rel="noopener noreferrer"
          >
            {source.title}
          </SourceLink>
        </SourceItem>
      ))}
    </SourcesList>
  );
};
